import { Injectable, inject } from '@angular/core';
import { ConfirmationModalComponent } from '../core/components/confirmation-modal/confirmation-modal.component';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Cmg1003ConstantsService } from '../cmg-1003/services/cmg-1003-constants.service';

@Injectable({
  providedIn: 'root',
})
export class InternetDisconnectService {
  private readonly _dialogService = inject(DialogService);
  private readonly _cmg1003ConstantsService = inject(Cmg1003ConstantsService);

  private _confirmationModal: DynamicDialogRef;

  showInternetDisconnectModal() {
    if (!this._confirmationModal) {
      const messageSpan = '<span>Try reconnecting your internet or contacting support to resolve the issue.</span>';
      const phoneSpan = '<span><i class="pi pi-phone"></i> <b>(833) 243-4264</b></span>';
      const emailSpan =
        '<span><i class="pi pi-envelope"></i> <a href="mailto:ClearSupport@cmgfi.com?subject=Lost internet connection">ClearSupport&#64;cmgfi.com</a></span>';
      const helpUrlSpan =
        '<span><i class="pi pi-desktop"></i> <a href="https://helpdesk.cmgmortgage.com" target="_blank">helpdesk.cmgmortgage.com</a></span>';

      this._confirmationModal = this._dialogService.open(ConfirmationModalComponent, {
        closable: true,
        width: '500px',
        styleClass: 'confirmation-modal-with-support-links',
        contentStyle: { 'max-height': '500px', overflow: 'auto' },
        baseZIndex: this._cmg1003ConstantsService.modalZIndex,
        data: {
          message: '<div class="d-flex flex-wrap flex-column">' + messageSpan + '<br>' + phoneSpan + emailSpan + helpUrlSpan + '</div>',
          header: 'Internet not connected. Please check connection.',
          icon: 'pi pi-exclamation-triangle',
          acceptLabel: 'OK',
          rejectLabel: null,
        },
      });
      this._confirmationModal.onClose.subscribe(() => (this._confirmationModal = null));
    }
  }

  isInternetDisconnected(errorStatus: number) {
    return !navigator.onLine || [0, 504].includes(errorStatus);
  }
}
